(function (){
    'use strict';
    angular.module('app').controller('ViewAllAccountsController',ViewAllAccountsController);
    ViewAllAccountsController.$inject=[
        'AffiliateAccountsTableService',
        '$location',
        '$routeParams',
        'AffiliateService'
    ];

    function ViewAllAccountsController(AffiliateAccountsTableService,$location,$routeParams,AffiliateService){
        const vm = this;
        vm.paramId = $routeParams.id;

        vm.goback = goback;
        vm.addNewAccount = creaNewAccount;
        init();

        function init(){
            getAccountDetails();
            vm.tableData = new AffiliateAccountsTableService().tableData;
        }

        function goback(){
            $location.path('/affiliates-sales/'+vm.paramId);
        }

        function creaNewAccount(){
            $location.path('/affiliates-sales/account/new');
        }

        function getAccountDetails(){
            AffiliateService.getCompanyDetails(
                res=>{
                    vm.company = res
                },
                err=>{
                    console.log(err)
                },$routeParams.id
            )
        }
    }

})()


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/accounts/ViewAllAccountController.js